module.exports = __webpack_public_path__ + "static/media/communs.32ba0d30.jpg";